import {VenueInfoCard} from "./VenueInfoCard";

export default VenueInfoCard;